import axios from "../../../../utils/request"

function GET_LIST(params) {
    return axios.get("/help/AHelpArticle/index", {
        params: {
            ...params
        }
    })
}

function ADD_DATA(params) {
    return axios.get("/help/AHelpArticle/add", {
        params: {}
    })
}

function EDIT_DATA(params) {
    return axios.post("/help/AHelpArticle/edit",
        {id: params}
    )
}

function SUBMIT_ADD(params) {
    return axios.post("/help/AHelpArticle/addPost", {...params})
}

function SUBMIT_EDIT(params) {
    return axios.post("/help/AHelpArticle/editPost", {...params})
}


function CHANG_STATUS(params) {
    return axios.post("/help/AHelpArticle/statusEdit", {status: params})
}

function DELE(params) {
    return axios.get("/help/AHelpArticle/delete", {
        params: {
            ids: params
        }
    })
}

function CHANG_TOP(params) {
    return axios.post("/news/ANews/topEdit", {is_top: params})
}

function LIST_ORDER(params) {
    return axios.post("/help/AHelpArticle/listOrder", {list_orders: params})
}

export default {
    GET_LIST,
    ADD_DATA,
    EDIT_DATA,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    CHANG_STATUS,
    DELE,
    CHANG_TOP,
    LIST_ORDER
}